<template>
  <div class="">
    <nav class="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top text-white">
      <div class="container">
        <a class="navbar-brand ml-md-5 font-weight-normal" href="/" style="color:#074053">
        <img src="@/assets/logo.png" alt="Oracle by devMoment" style="width: 25%;" >
        </a>
         
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div class="collapse navbar-collapse " id="navbarResponsive">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link" href="https://devmoment.com" style="color: blueviolet;">Our Blog</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  name: "SideMenu"
}
</script>